<template>
  <el-form-item
    :key="form.key"
    :label="form.cname+':'"
    :prop="prop"
    :rules="rule">
    <div v-if="status === 'edit'">
      <el-input-number
        v-model="form.fieldValue"
        :disabled="form.checked"
        :controls="false"
        :precision="4"
        :min="0"
        :max="100000"></el-input-number>
      <el-select
        v-model="form.unitFieldValue"
        :disabled="form.checked"
        style="width:100px;margin-left: 5px;">
        <el-option
          v-for="sitem in form.unitEnumValues"
          :key="sitem.value"
          :label="sitem.label"
          :value="sitem.value">
        </el-option>
      </el-select>
      <el-checkbox
        v-model="form.checked"
        style="margin-left: 5px;">详见包装</el-checkbox>
    </div>
    <span v-else>
      <span v-if="form.checked">详见包装</span>
      <span v-else>{{ name || '&nbsp;' }}</span>
    </span>
  </el-form-item>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'FormUnit',
  props: {
    item: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    },
    prop: {
      type: String,
      required: true
    },
    status: {
      type: String,
      default: 'edit'
    }
  },
  computed: {
    form: {
      get() {
        return this.item
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    name() {
      return this.form.fieldValue + (_.find(this.form.unitEnumValues, o => o.value === this.form.unitFieldValue) || {}).label
    },
    rule() {
      return [
        {
          required: this.form.mandatory,
          message: this.form.cname + '不能为空',
          trigger: 'blur'
        }
      ]
    }
  }
}
</script>
